import * as React from 'react'
import {
  SimpleAccordion,
  SimpleAccordionDetails,
  SimpleAccordionSummary,
} from '@sales-center/components'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

type Props = {
  title: string
  subtitle: string
  children: React.ReactNode
  paddingTop?: number
}

export function CollapsibleSection(props: Props) {
  const { title, subtitle, children, paddingTop } = props
  return (
    <SimpleAccordion
      defaultExpanded
      sx={{ paddingX: 2, paddingTop: paddingTop || 0 }}
    >
      <SimpleAccordionSummary>
        <Typography variant="h7">{title}</Typography>
      </SimpleAccordionSummary>
      <SimpleAccordionDetails>
        <Box width="100%" mt={0.5}>
          <Typography variant="subtitle2">{subtitle}</Typography>

          <Box py={1.5}>{children}</Box>
        </Box>
      </SimpleAccordionDetails>
    </SimpleAccordion>
  )
}

CollapsibleSection.displayName = 'CollapsibleSection'
